import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import { withTranslation, WithTranslation } from 'react-i18next';
import { compose } from 'redux';
import { UserStream, Props as WidgetProps } from './UserStream';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../../UserWidgets/_partials/WidgetBoxWide';
import getStatLine from '../../../utils/getStatLine';
import EmptyState from '../../EmptyState';
import { URLS } from '@wix/da-url';
import UserStreamConfigPopover from './UserStreamConfigPopover';

import s from './UserStreamBox.scss';

class UserStreamBoxWide extends React.Component<
  WidgetProps &
    WidgetBoxWideProps &
    WithTranslation & {
      type: 'watchers' | 'watching';
      totalCount?: number;
      isOwner: boolean;
      profileOwnerUser: PapiUser;
      withConfig?: boolean;
    }
> {
  render() {
    const {
      id,
      type,
      subHeader,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      totalCount,
      hasMore,
      fetchMore,
      isFetching,
      isEmpty,
      isOwner,
      widgetMenuRenderer,
      widgetMoveUp,
      widgetMoveDown,
      parentRef,
      widgetRemove,
      widgetBoxClassName,
      withConfig,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBoxWide
        section={section}
        zone={zone}
        moduleId={props.moduleId}
        id={id}
        header={props.t(`widgets.${type}.header`)}
        count={totalCount}
        subHeader={getStatLine(props.t!, type, totalCount)}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        hasMore={hasMore}
        fetchMore={fetchMore}
        isFetching={isFetching}
        parentRef={parentRef}
        widgetMenuRenderer={
          withConfig
            ? close => (
                <UserStreamConfigPopover
                  withManageLink={type === 'watching'}
                  moduleId={props.moduleId}
                  onClose={close}
                />
              )
            : undefined
        }
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        className={widgetBoxClassName}
        isEmpty={isEmpty}
        emptyView={
          isOwner ? (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!(`widgets.${type}.empty.title.owner`)}
              subtitle={props.t!(`widgets.${type}.empty.subtitle.owner`)}
              buttonLabel={props.t!(`widgets.${type}.empty.CTALabel.owner`)}
              withButton={true}
              onButtonClick={this.navigateToBrowse}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!(`widgets.${type}.empty.title.visitor`, {
                username: props.profileOwnerUser.username,
              })}
              subtitle={props.t!(`widgets.${type}.empty.subtitle.visitor`, {
                username: props.profileOwnerUser.username,
              })}
            />
          )
        }
      >
        <UserStream {...props} />
      </WidgetBoxWide>
    );
  }

  navigateToBrowse() {
    window.location.replace(URLS.ROOT);
  }
}
const enhance = compose(withTranslation());

export default enhance(UserStreamBoxWide) as React.ComponentType<{}>;
